<template>

  <select
    :id="name"
    :name="name"
    v-model="value"
    @focus="onFocusFormControlEl"
  >
    <option v-for="option in options" :value="option.value">{{option.text}}</option>
  </select>

</template>

<script>
  export default {
    name: 'FormControlSelect',

    props: {
      name: {
        type: String,
        required: true,
      },
      options: {
        type: Array,
        required: true,
      },
    },

    data() {
      return {
        value: null,

      };
    },

    computed: {
      filled() {
        return this.value === null
          ? false
          : this.value;
      },
    },

    watch: {
      value(value) {
          this.$emit('value', value);
      },
      filled(value) {
        this.$emit('filled', value);
      },
      focused(value) {
          this.$emit('focused', value);
      },
    },

    methods: {
        onFocusFormControlEl() {
            this.focused = true;
        },

        onBlurFormControlEl() {
            this.focused = false;
        },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/FormControlSelect.vue